<template>
  <modal
    id="cookie-banner"
    :show="displayConsentBanner"
    :has-close-button="false"
    :close-on-background-click="false"
    :modifiers="['rounded-border', 'grey-pale']"
    :close-on-escape="false"
    tracking-name="popup-20200728-cookie-banner">
    <template v-slot:disclaimer>
      <cookie-disclaimer />
    </template>
    <template v-slot:settings>
      <cookie-settings />
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "/shared/modal";
import CookieDisclaimer from "./cookie-disclaimer";
import CookieSettings from "./cookie-settings";

export default {
  name: "CookieBanner",
  components: {
    Modal,
    CookieDisclaimer,
    CookieSettings
  },
  computed: {
    ...mapGetters(["displayConsentBanner"])
  }
};
</script>
